module.exports = __webpack_public_path__ + "img/d-1-3.03906ae1.png";